import classnames from 'classnames'
import styles from './styles.module.scss'

const ErrorMessage = ({ messages, className, type = 'message' }) =>
    type === 'text' ? (
        messages.map((message, index) => (
            <p className={classnames(styles.errorText, { [className]: !!className })} key={index}>
                {message}
            </p>
        ))
    ) : (
        <div className={classnames(styles.errorMessage, { [className]: !!className })}>
            {messages.map((message, index) => (
                <p className={styles.text} key={index}>
                    {message}
                </p>
            ))}
        </div>
    )

ErrorMessage.propTypes = {
    type: PropTypes.oneOf(['text', 'message']),
    className: PropTypes.string,
    messages: PropTypes.arrayOf(PropTypes.string),
}

export default ErrorMessage
